import { render, staticRenderFns } from "./InheritHeader.vue?vue&type=template&id=13a76f99&scoped=true&"
import script from "./InheritHeader.vue?vue&type=script&lang=js&"
export * from "./InheritHeader.vue?vue&type=script&lang=js&"
import style0 from "./InheritHeader.vue?vue&type=style&index=0&id=13a76f99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a76f99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardTitle,VSpacer})
